module.exports = {
  init: () => {
    let scrollPos = 0;

    headerUpdate();
    $(window).on("scroll", headerUpdate);
    $(window).on("resize", headerUpdate);

    function headerUpdate() {
      let header = $(".header");
      let dummy = $(".header-dummy");
      let scrolled = $(window).scrollTop();

      if (scrolled > scrollPos) {
        if (isOutside(dummy)) {
          header.addClass("header--hide");
        }
      } else {
        header.removeClass("header--hide");
      }
      scrollPos = scrolled;

      function isOutside(e) {
        if (scrolled > e.height() + $(e).offset().top) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
};
